document.addEventListener('DOMContentLoaded', function() {
    const filter = document.getElementById('state-filter');
    const stateBlocks = document.querySelectorAll('.store-state-block');
    const zipCodeInput = document.getElementById('zip-code');
    const zipCodeError = document.querySelector('.store-locator__zip-code-error');
    const noResultsText = document.querySelector('.store-locator').dataset.noResultsText;

    // Add smooth filtering animation
    function filterStores(selectedValue) {
      zipCodeStoresGrid.innerHTML = '';
      if(storeList.style.display == 'none') storeList.style.display = 'block';

      // reset zip code error
      zipCodeError.textContent = '';
      zipCodeError.style.display = 'none';

      stateBlocks.forEach((block, index) => {
        const shouldShow = selectedValue === 'all' || block.dataset.state === selectedValue;

        if (shouldShow) {
          block.style.display = 'block';
          setTimeout(() => {
            block.style.opacity = '1';
            block.style.transform = 'translateY(0)';
          }, index * 50);
        } else {
          block.style.opacity = '0';
          block.style.transform = 'translateY(20px)';
          setTimeout(() => {
            block.style.display = 'none';
          }, 300);
        }
      });
    }

    filter.addEventListener('change', function() {
      filterStores(this.value);
    });



    //  filtering by zip code 
     const getRegionsWithStores = () => {
       const regionsWithStoresArray = [];
       const allStatesBlock = document.querySelectorAll('.store-state-block');
      allStatesBlock.forEach(stateEl => {
        const stateName = stateEl.dataset.state;

        const stateStores = stateEl.querySelectorAll('.store-item');
        const stateStoresArray = [];
        
        [...stateStores]?.forEach(storeEl => {
          const store = {
            storeEl,
            longitude: storeEl.dataset.longitude,
            latitude: storeEl.dataset.latitude,
          }
          stateStoresArray.push(store);
        });

        const stateOjb = {
          stateName,
          stores: stateStoresArray,
        }
        
        regionsWithStoresArray.push(stateOjb);
      });

      return regionsWithStoresArray;
    }

    const regionsWithStores = getRegionsWithStores();
    const storeList = document.querySelector('#store-list');
    const zipCodeStoresGrid = document.querySelector('.store-grid--zip-code');

    function toRad(d){ return d*Math.PI/180; }
    
    function distanceMiles(a, b){
      const R = 6371; // km
      const dLat = toRad(b.lat - a.lat), dLon = toRad(b.lng - a.lng);
      const lat1 = toRad(a.lat), lat2 = toRad(b.lat);
      const h = Math.sin(dLat/2)**2 + Math.cos(lat1)*Math.cos(lat2)*Math.sin(dLon/2)**2;
      return (2*R*Math.asin(Math.sqrt(h))) * 0.621371;
    }

     async function filterStoresByZipCode(zipCode) {

      // if filter is not all, set it to all
      if(filter.value !== 'all'){
        filter.value = 'all';
        filter.dispatchEvent(new Event('change'));
      }

      // reset zip code error
      zipCodeError.innerHTML = '';
      zipCodeError.style.display = 'none';

      if(zipCode.length === 0){
        zipCodeStoresGrid.innerHTML = '';
        storeList.style.display = 'block';
        return;
      }
      if(zipCode.length !== 5) {
        zipCodeStoresGrid.innerHTML = '';
        storeList.style.display = 'none';
        zipCodeError.textContent = 'ZIP code must be 5 digits';
        zipCodeError.style.display = 'block';
        // do something for reset 
        return;
      }
      storeList.style.display = 'none';

      try{
        // get zip code data and prepare coords object for filtering
        const getZipCodeData = await fetch('https://api.zippopotam.us/us/' + zipCode);
        const data = await getZipCodeData.json();
        const places = data.places;
        if(!places) {
          zipCodeStoresGrid.innerHTML = '';
          throw new Error('No zip code found');
          // do something for reset 
          return;
        }
        const firstPlace = places[0];
        const firstPlaceCoords = {
          lat: parseFloat(firstPlace.latitude),
          lng: parseFloat(firstPlace.longitude),
        }

        // get filtered stores
        const filteredStores = regionsWithStores.map(region => {
          const regionStores = region.stores;
          const filteredRegionStores = [];

          regionStores.forEach(store => {
            const storeCoords = {
              lat: parseFloat(store.latitude),
              lng: parseFloat(store.longitude),
            }

            const distance = distanceMiles(firstPlaceCoords, storeCoords) ? parseFloat(distanceMiles(firstPlaceCoords, storeCoords).toFixed(1)) : null

            // prepare store info object
            const storeInfo = {
              storeEl: store.storeEl,
              distance: distance,
            }

            // if store has distance, add it to the filtered region stores
            if (storeInfo.distance && storeInfo.distance < 50) filteredRegionStores.push(storeInfo);
          });
          return filteredRegionStores;
        })



        const flatArray = filteredStores.flat();
        const sortedArrayByDistance = flatArray.sort((a, b) => a.distance - b.distance).slice(0, 10);

        // update the store grid
        zipCodeStoresGrid.innerHTML = '';

        if(sortedArrayByDistance.length > 0){
          sortedArrayByDistance.forEach(store => {
            const cloneStoreEl = store.storeEl.cloneNode(true);
            cloneStoreEl.querySelector('.store-distance').textContent = store.distance + ' miles';
            zipCodeStoresGrid.appendChild(cloneStoreEl);
          });
        } else {
          zipCodeError.innerHTML = noResultsText;
          zipCodeError.style.display = 'block';
        }

      } catch(error) {
        zipCodeError.textContent = 'Something went wrong';
        zipCodeError.style.display = 'block';
      }
    }

    zipCodeInput.addEventListener('input', function() {
      filterStoresByZipCode(this.value);
    });

    zipCodeInput.addEventListener('change', function() {
      filterStoresByZipCode(this.value);
    });

    // Initialize with fade-in animation
    setTimeout(() => {
      stateBlocks.forEach(block => {
        block.style.opacity = '1';
        block.style.transform = 'translateY(0)';
      });
    }, 100);
  });